import React from 'react'
import { withRouter, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import NProgress from 'nprogress'
import Loader from 'components/Loader'
import LocaleSettingsModal from 'components/LocaleSettingsModal'
import CookiesPolicyAgreement from 'components/CookiesPolicyAgreement'
import Notifications from 'components/Notifications'
import errorBoundaryEnhancer from 'services/errorBoundaryEnhancer'
import SupportChat from 'components/SupportChat'
import AirLayout from './AirLayout'
import MainLayout from './Main'

// TODO: refactor component
NProgress.configure({ showSpinner: false })

const LayoutsMap = {
  air: AirLayout,
  main: MainLayout,
}

class IndexLayout extends React.PureComponent {
  previousPath = ''

  render() {
    const {
      children,
      location: { pathname, search },
      user
    } = this.props

    // NProgress Management
    const currentPath = pathname + search
    if (currentPath !== this.previousPath) {
      NProgress.start()
    }

    setTimeout(() => {
      NProgress.done()
      this.previousPath = currentPath
    }, 300)

    // Layout Rendering
    const getLayout = () => {
      if (
        pathname.includes('/login') ||
        pathname.includes('/verification') ||
        pathname.includes('/create-goal') ||
        pathname.includes('/goal-report') ||
        pathname.includes('/business-reputation-intro')
      ) {
        return 'air'
      }

      return 'main'
    }

    const Container = LayoutsMap[getLayout()]
    const isUserAuthorized = user.accessToken !== ''
    const isUserLoading = user.loading
    const isUserUnverified = user.state === 'unverified'
    const isAirLayout = getLayout() === 'air'
    const isVerificationPath = pathname.includes('/verification')

    if (isUserLoading && !isUserAuthorized && !isAirLayout) {
      return <Loader />
    }

    if (!isUserAuthorized && (isVerificationPath || !isAirLayout)) {
      return <Redirect to="/login" />
    }

    if (isUserUnverified && !pathname.includes('/verification')) {
      return <Redirect to="/verification" />
    }

    return (
      <>
        <Container>
          {children}
          <LocaleSettingsModal />
        </Container>
        <SupportChat />
        <CookiesPolicyAgreement />
        {isUserAuthorized && <Notifications />}
      </>
    )
  }
}

export default errorBoundaryEnhancer(withRouter(connect(({ user, settings }) => ({ user, settings }))(IndexLayout)))
